import React from 'react';
import { Col } from 'react-bootstrap';

const GalleryImage = ({ image }) => {
    return (
        <Col>
            <img className="img-fluid" src={image.image} alt="" />
        </Col>
    );
};

export default GalleryImage;